import type { ReactElement } from "react";

import classNames from "classnames";

import {
    StyledOnboardingHubButtonContainer,
    StyledOnboardingHubContentWrapper,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubSidebarContainer/styles";
import type {
    OnboardingHubHeaderBaseProps,
} from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubHeader/OnboardingHubHeader";
import OnboardingHubHeader from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubHeader/OnboardingHubHeader";
import type { OnboardingHubProgressBaseProps } from "app/pages/sales-intelligence/sub-modules/onboarding/sidebar-hub/components/OnboardingHubProgress/OnboardingHubProgress";
import { SWReactIcons } from "@similarweb/icons";

interface OnboardingHubSidebarContainerProps extends OnboardingHubHeaderBaseProps, OnboardingHubProgressBaseProps {
    isShowHubButton: boolean;
    isActive?: boolean;
    isLoading: boolean;
    isHubClosed: boolean;
    onHovered?: () => void;
    onClick?: () => void;
    children: ReactElement;
}

const OnboardingHubSidebarContainer = ({
    onClick,
    isShowHubButton,
    isHubClosed,
    isActive,
    isLoading,
    completedItemsCount,
    totalItemsCount,
    onHovered,
    isShowClose,
    onClose,
    children,
}: OnboardingHubSidebarContainerProps): ReactElement => {
    return (
        <StyledOnboardingHubButtonContainer
            onMouseEnter={onHovered}
            onClick={onClick}
            className={classNames(
                (isActive || isLoading) && "dropdownDisabled",
                isShowHubButton && "isShowHubButton",
                isHubClosed && "isHubClosed",
                !totalItemsCount && "isButton",
            )}
        >
            <StyledOnboardingHubContentWrapper>
                {!totalItemsCount ? <div>
                        <SWReactIcons
                            iconName="checklist"
                            size="md"
                        />
                    </div> : null}
                <OnboardingHubHeader
                    completedItemsCount={completedItemsCount}
                    totalItemsCount={totalItemsCount}
                    isShowClose={isShowClose}
                    isExtended={false}
                    onClose={onClose}
                />
            </StyledOnboardingHubContentWrapper>
            {!isLoading ? children : null}
        </StyledOnboardingHubButtonContainer>
    );
};

export default OnboardingHubSidebarContainer;
